import { STEP_KEYS } from './step_definitions';

const PAYMENT_TIMING = {
  AFTER_SUBMISSION: 'after_submission'
};

const DEFAULT_STEP_ORDER = [
  STEP_KEYS.PERSONAL_INFO,
  STEP_KEYS.LEASE_INFO,
  STEP_KEYS.ORG_TERMS,
  STEP_KEYS.IDENTITY,
  STEP_KEYS.HOUSING,
  STEP_KEYS.BACKGROUND_CHECK,
  STEP_KEYS.APP_FEE,
  STEP_KEYS.HOUSEHOLD,
  STEP_KEYS.PETS,
  STEP_KEYS.VEHICLES,
  STEP_KEYS.INCOME_VERIFICATION,
  STEP_KEYS.INCOME,
  STEP_KEYS.SUBMIT,
  STEP_KEYS.SUCCESS
];

const PAYMENT_AFTER_SUBMISSION_ORDER = [
  STEP_KEYS.PERSONAL_INFO,
  STEP_KEYS.LEASE_INFO,
  STEP_KEYS.ORG_TERMS,
  STEP_KEYS.IDENTITY,
  STEP_KEYS.HOUSING,
  STEP_KEYS.BACKGROUND_CHECK,
  STEP_KEYS.HOUSEHOLD,
  STEP_KEYS.PETS,
  STEP_KEYS.VEHICLES,
  STEP_KEYS.INCOME_VERIFICATION,
  STEP_KEYS.INCOME,
  STEP_KEYS.SUBMIT,
  STEP_KEYS.APP_FEE,
  STEP_KEYS.SUCCESS
];

export default (companyContext) => {
  if (companyContext?.paymentTiming === PAYMENT_TIMING.AFTER_SUBMISSION) {
    return PAYMENT_AFTER_SUBMISSION_ORDER;
  }
  return DEFAULT_STEP_ORDER;
};
